import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  static values = {
    behavior: { type: String, default: "auto" },
  };

  connect() {
    this.atBottom = true;
    this.scrollToBottom();

    this.resizeObserver = new ResizeObserver(() => {
      if (this.atBottom) this.scrollToBottom();
    });
    this.resizeObserver.observe(this.element);
    this.resizeObserver.observe(this.contentTarget);
  }

  disconnect() {
    this.resizeObserver.disconnect();
  }

  rememberPosition() {
    this.atBottom =
      this.element.scrollHeight -
        this.element.clientHeight -
        this.element.scrollTop <=
      1;
  }

  scrollToBottom() {
    this.element.scrollTo({
      top: this.element.scrollHeight,
      behavior: this.behaviorValue,
    });
  }
}
